module.exports = __webpack_public_path__ + "0ed8a63b59ee1183333d247550c46033.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/houses/chefs-palace-empty.png
// module id = 316
// module chunks = 0